module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parentgoback"
  }, [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.goback
      }),
      expression: "{methods:goback}"
    }],
    staticClass: "btn"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a1be74e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VGoBackBtn.vue
// module id = 761
// module chunks = 1